import { TabContext, TabPanel } from "@mui/lab";
import { Badge, Box, IconButton } from "@mui/material";
import FlexBox from "../../components/FlexBox";
import { H4, H6, Paragraph, Tiny } from "../../components/Typography";
import moment from "moment";
import React, { FC, Fragment, useRef, useState } from "react";
import PopoverLayout from "./PopoverLayout";
import { useAppDispatch } from "../../store/hooks";
import { getNotificationList, updateNotificationList } from "../../redux/actions";
import { load } from "../../constants/storage";

const NotificationsPopover: FC = () => {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [tabValue, setTabValue] = useState("1");
  const [notifications, setNotifications] = React.useState([]);

  const [notificationCount, setNotificationCount] = React.useState([]);

  React.useEffect(() => {
    getNotificationListApi();
  }, []);

  const dispatch = useAppDispatch();
  const getNotificationListApi = async () => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    let token = load("token");
    dispatch(getNotificationList(userDetails.mobile, token))
      .then(async (response: any) => {
        if (
          response?.statusCode === 200 ||
          response?.statusCode === 201 ||
          response?.statusCode === 204
        ) {
          setNotifications(response?.notificationList ?? []);
          setNotificationCount(
            response?.notificationList?.filter(
              (item: any) => item?.isMsgOpen === "false"
            ) ?? []
          );
          return;
        }
        setNotifications([]);
      })
      .catch((error: any) => {
        setNotifications([]);
      });
  };
  const updateNotifications = async () => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    let token = load("token");
    dispatch(updateNotificationList(userDetails.mobile, token))
      .then(async (response: any) => {
        getNotificationListApi();
      })
      .catch((error: any) => {
        return;
      });
  };
  return (
    <Fragment>
      <IconButton
        ref={anchorRef}
        onClick={() => {
          setOpen(true);
        }}
      >
        <Badge
          sx={{
            height: {
              xs: "75%",
              sm: "60%",
              md: "100%",
            },
            width: {
              xs: "75%",
              sm: "60%",
              md: "100%",
            },
            ml: {
              xs: -2,
              sm: 0,
              md: 0,
            },
          }}
          badgeContent={notificationCount.length}
          color="error"
        >
          <Box
            component="img"
            sx={{
              height: {
                xs: "100%",
                sm: "60%",
                md: "100%",
              },
              width: {
                xs: "100%",
                sm: "60%",
                md: "100%",
              },
              mr: {
                xs: 2,
                sm: 0,
                md: 0,
              },
            }}
            src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/notification.svg"
            alt="saas-dasboard-footer"
          />
        </Badge>
      </IconButton>
      <PopoverLayout
        title="Notifications"
        popoverOpen={open}
        anchorRef={anchorRef}
        marginFromTop={8}
        popoverClose={() => {
          setOpen(false);
          updateNotifications();
        }}
      >
        <TabContext value={tabValue}>
          {notifications.length === 0 ? (
            <Paragraph fontWeight="500" textAlign="center" p={2}>
              There are no new notifications.
            </Paragraph>
          ) : (
            <TabPanel value="1">
              <H4
                fontWeight={"700"}
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  marginTop: -2,
                }}
              >
                All Notifications
              </H4>
              {notifications.map((msg, index) => (
                <ListItem msg={msg} key={index} />
              ))}
            </TabPanel>
          )}
        </TabContext>
      </PopoverLayout>
    </Fragment>
  );
};

type ListItemProps = {
  msg: {
    isMsgOpen: string;
    createdAt: string;
    message: string;
  };
};
function ListItem({ msg }: ListItemProps) {
  let timestamp = msg?.createdAt;
  let date = new Date(timestamp);
  let transactionDate = moment(date).format("DD MMM YYYY");
  let transactionTime = moment(date).format("hh:mm A");

  return (
    <FlexBox
      alignItems="center"
      sx={{
        borderBottom: 1,
        cursor: "pointer",
        borderColor: "divider",
        backgroundColor: "transparent",
        pt: 2,
        pb: 2,
      }}
    >
      <Box>
        {msg.isMsgOpen === "true" ? (
          <H6
            display="block"
            fontWeight={500}
            color="text.disabled"
            sx={{
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            {msg.message}
          </H6>
        ) : (
          <H6
            sx={{
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            {msg.message}
          </H6>
        )}
        <Box
          sx={{
            flexDirection: "row",
            justifyContent: "space-between",
            display: "flex",
            mt: 1,
          }}
        >
          <Tiny
            display="block"
            fontWeight={500}
            color="text.disabled"
            sx={{
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            {transactionDate}
          </Tiny>
          <Tiny
            display="block"
            fontWeight={500}
            color="text.disabled"
            sx={{
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            {transactionTime}
          </Tiny>
        </Box>
      </Box>
    </FlexBox>
  );
}

export default NotificationsPopover;
